var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { BatteryLifeClient, CompaniesClient, SitesClient, SettingsClient, ReportScheduleModel, GetStringLifeQuery } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const batteryLifeClient = new BatteryLifeClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
const settingsClient = new SettingsClient(window.apiUrl);
let StringLifeReportFilterVue = class StringLifeReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.displayAdvancedFilter = false;
        this.companies = [];
        this.sites = [];
        this.query = new GetStringLifeQuery();
    }
    created() {
        this.getLookups();
        this.loadSavedSettingsForCompany();
    }
    ;
    mounted() {
        this.loadReportScheduleQuery();
    }
    ;
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = [{ value: null, text: `All companies` }].concat(companies);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            }),
            siteClient
                .getListForUser()
                .then(response => {
                this.sites = response;
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (!this.validateParameters())
            return null;
        this.query.timezoneOffset = moment().utcOffset();
        return this.query;
    }
    ;
    validateParameters() {
        try {
            if (Number(this.query.ageColumn1Parameter) >= Number(this.query.ageColumn2Parameter)) {
                Notifier.onError("Calendar Age Lower Range cannot be greater than or equal to Middle Range");
                return false;
            }
            if (Number(this.query.ageColumn2Parameter) >= Number(this.query.ageColumn3Parameter)) {
                Notifier.onError("Calendar Age Middle Range cannot be greater than or equal to Upper Range");
                return false;
            }
            if (Number(this.query.replacementColumn1Parameter) >= Number(this.query.replacementColumn2Parameter)) {
                Notifier.onError("Replacement Lower Range cannot be greater than or equal to Middle Range");
                return false;
            }
            if (Number(this.query.replacementColumn2Parameter) >= Number(this.query.replacementColumn3Parameter)) {
                Notifier.onError("Replacement Middle Range cannot be greater than or equal to Upper Range");
                return false;
            }
            if (Number(this.query.ohmicRiseColumn1Parameter) >= Number(this.query.ohmicRiseColumn2Parameter)) {
                Notifier.onError("Ohmic Rise (%) Lower Range cannot be greater than or equal to Middle Range");
                return false;
            }
            if (Number(this.query.ohmicRiseColumn2Parameter) > Number(this.query.ohmicRiseColumn3Parameter)) {
                Notifier.onError("Ohmic Rise (%) Middle Range cannot be greater than Upper Range");
                return false;
            }
            if (Number(this.query.predictedColumn1Parameter) >= Number(this.query.predictedColumn2Parameter)) {
                Notifier.onError("End Of Life Lower Range cannot be greater than or equal to Middle Range");
                return false;
            }
            if (Number(this.query.predictedColumn2Parameter) >= Number(this.query.predictedColumn3Parameter)) {
                Notifier.onError("End Of Life Middle Range cannot be greater than or equal to Upper Range");
                return false;
            }
            return true;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    exportToPdf() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            batteryLifeClient.downloadStringLifeAsPDF(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                let blob = new Blob([response.data], { type: 'application/pdf;base64' });
                let url = URL.createObjectURL(blob);
                var popUp = window.open(url, '_blank');
                if (popUp == null || typeof (popUp) == 'undefined') {
                    alert('Please disable your pop-up blocker and try again.');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    exportToCsv() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            batteryLifeClient.downloadStringLifeAsCsv(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                DownloadUtil.handleFileDownload(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    ;
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery(false);
    }
    ;
    onCompanyIdChanged() {
        if (!this.working) {
            this.query.siteId = null;
            this.loadSavedSettingsForCompany();
        }
    }
    setValidationFields() {
        this.setFieldValue("ageColumn1", this.query.ageColumn1Parameter);
        this.setFieldValue("ageColumn2", this.query.ageColumn2Parameter);
        this.setFieldValue("ageColumn3", this.query.ageColumn3Parameter);
        this.setFieldValue("replacementColumn1", this.query.replacementColumn1Parameter);
        this.setFieldValue("replacementColumn2", this.query.replacementColumn2Parameter);
        this.setFieldValue("replacementColumn3", this.query.replacementColumn3Parameter);
        this.setFieldValue("ohmicRiseColumn1", this.query.ohmicRiseColumn1Parameter);
        this.setFieldValue("ohmicRiseColumn2", this.query.ohmicRiseColumn2Parameter);
        this.setFieldValue("ohmicRiseColumn3", this.query.ohmicRiseColumn3Parameter);
        this.setFieldValue("predictedColumn1", this.query.predictedColumn1Parameter);
        this.setFieldValue("predictedColumn2", this.query.predictedColumn2Parameter);
        this.setFieldValue("predictedColumn3", this.query.predictedColumn3Parameter);
    }
    loadSavedSettingsForCompany() {
        settingsClient
            .getStringLifeReportSettingsForCompany(this.query.companyId)
            .then((response) => {
            if (!response)
                return;
            this.query.ageMethod = response.ageMethod;
            // Age
            this.query.ageColumn1Parameter = response.ageColumn1Parameter;
            this.query.ageColumn2Parameter = response.ageColumn2Parameter;
            this.query.ageColumn3Parameter = response.ageColumn3Parameter;
            // Replacement
            this.query.replacementColumn1Parameter = response.replacementColumn1Parameter;
            this.query.replacementColumn2Parameter = response.replacementColumn2Parameter;
            this.query.replacementColumn3Parameter = response.replacementColumn3Parameter;
            // Ohmic Rise
            this.query.ohmicRiseColumn1Parameter = response.ohmicRiseColumn1Parameter;
            this.query.ohmicRiseColumn2Parameter = response.ohmicRiseColumn2Parameter;
            this.query.ohmicRiseColumn3Parameter = response.ohmicRiseColumn3Parameter;
            // Predicted
            this.query.predictedColumn1Parameter = response.predictedColumn1Parameter;
            this.query.predictedColumn2Parameter = response.predictedColumn2Parameter;
            this.query.predictedColumn3Parameter = response.predictedColumn3Parameter;
            this.setValidationFields();
        });
    }
    ;
    schedule() {
        var reportQuery = this.getQuery();
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    ;
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            this.working = true;
            var query = JSON.parse(queryString);
            this.query.companyId = query.companyId;
            this.query.siteId = query.siteId;
            this.query.ageMethod = query.ageMethod;
            // Age
            this.query.ageColumn1Parameter = query.ageColumn1Parameter;
            this.query.ageColumn2Parameter = query.ageColumn2Parameter;
            this.query.ageColumn3Parameter = query.ageColumn3Parameter;
            // Replacement
            this.query.replacementColumn1Parameter = query.replacementColumn1Parameter;
            this.query.replacementColumn2Parameter = query.replacementColumn2Parameter;
            this.query.replacementColumn3Parameter = query.replacementColumn3Parameter;
            // Ohmic Rise
            this.query.ohmicRiseColumn1Parameter = query.ohmicRiseColumn1Parameter;
            this.query.ohmicRiseColumn2Parameter = query.ohmicRiseColumn2Parameter;
            this.query.ohmicRiseColumn3Parameter = query.ohmicRiseColumn3Parameter;
            // Predicted
            this.query.predictedColumn1Parameter = query.predictedColumn1Parameter;
            this.query.predictedColumn2Parameter = query.predictedColumn2Parameter;
            this.query.predictedColumn3Parameter = query.predictedColumn3Parameter;
            this.setValidationFields();
            this.$nextTick(() => {
                this.working = false;
            });
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
    get sitesFiltered() {
        var filteredSites = this.sites.filter(site => !this.query.companyId || site.companyId == this.query.companyId);
        let sites = (filteredSites || []).map(item => {
            return {
                value: item.siteId,
                text: item.siteName || ""
            };
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    get selectedSite() {
        return this.sitesFiltered.filter(item => {
            return item.value == this.query.siteId;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.query.siteId = item.value;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], StringLifeReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringLifeReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], StringLifeReportFilterVue.prototype, "onCompanyIdChanged", null);
StringLifeReportFilterVue = __decorate([
    Component({
        name: "StringLifeReportFilterVue",
        emits: ["schedule", "updateSchedule"],
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue } = useForm({
                validationSchema: yup.object({
                    ageColumn1: yup.number().integer().min(0).max(100),
                    ageColumn2: yup.number().integer().min(0).max(100),
                    ageColumn3: yup.number().integer().min(0).max(100),
                    replacementColumn1: yup.number().integer().min(0).max(100),
                    replacementColumn2: yup.number().integer().min(0).max(100),
                    replacementColumn3: yup.number().integer().min(0).max(100),
                    ohmicRiseColumn1: yup.number().integer().min(0).max(100),
                    ohmicRiseColumn2: yup.number().integer().min(0).max(100),
                    ohmicRiseColumn3: yup.number().integer().min(0).max(100),
                    predictedColumn1: yup.number().integer().min(0).max(100),
                    predictedColumn2: yup.number().integer().min(0).max(100),
                    predictedColumn3: yup.number().integer().min(0).max(100)
                })
            });
            const ageColumn1Val = defineInputBinds('ageColumn1');
            const ageColumn2Val = defineInputBinds('ageColumn2');
            const ageColumn3Val = defineInputBinds('ageColumn3');
            const replacementColumn1Val = defineInputBinds('replacementColumn1');
            const replacementColumn2Val = defineInputBinds('replacementColumn2');
            const replacementColumn3Val = defineInputBinds('replacementColumn3');
            const ohmicRiseColumn1Val = defineInputBinds('ohmicRiseColumn1');
            const ohmicRiseColumn2Val = defineInputBinds('ohmicRiseColumn2');
            const ohmicRiseColumn3Val = defineInputBinds('ohmicRiseColumn3');
            const predictedColumn1Val = defineInputBinds('predictedColumn1');
            const predictedColumn2Val = defineInputBinds('predictedColumn2');
            const predictedColumn3Val = defineInputBinds('predictedColumn3');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                ageColumn1Val,
                ageColumn2Val,
                ageColumn3Val,
                replacementColumn1Val,
                replacementColumn2Val,
                replacementColumn3Val,
                ohmicRiseColumn1Val,
                ohmicRiseColumn2Val,
                ohmicRiseColumn3Val,
                predictedColumn1Val,
                predictedColumn2Val,
                predictedColumn3Val,
            };
        }
    })
], StringLifeReportFilterVue);
export default StringLifeReportFilterVue;
